export enum SalesPriceOptionEnum {
    BILLS_PRICE = 'BILLS_PRICE',
    PLANNING_PRICE = 'PLANNING_PRICE',
}
